// function isUserOfSameHospital(user: any, identity: any, context: any) { return true }

/**
 *  Reference:  d: delete, w: write/edit, c: create, r: read, l: list, h: hide
 */
export default  [
  { role: 'business',    target: 'budget.status',   permissions: 'h' }
]
